import { FC, PropsWithChildren } from "react";

import { Auth } from "./Auth";
import { useAuth } from "../../hooks";

export const AuthGuard: FC<PropsWithChildren> = ({ children }) => {
  const { logged } = useAuth();

  return logged ? <>{children}</> : <Auth />;
};
